import md5 from './md5.js'
import Base64 from './base64.js'
import common from './comm.js'
import router from '../../router'
import {
    Api
} from "@/assets/js/api";

// appid和密钥
let appid = common.appid;
let appsecret = common.appsecret;

// 获取域名
function getDomainName() {
    let domain = location.host || '';
    if (common.serve_s == 'dev') {
        domain = common.domain || ''
    }
    return domain
}
// 获取企业编号
function getEnterpriseNo() {
    let EnterpriseNo = window.localStorage.getItem('EnterpriseNo') || ''
    // let EnterpriseNo = 'huayuan1001'  //集运
    // let EnterpriseNo = 'bamibuytest'     //代购
    return EnterpriseNo
}

// 是否货猫(一些页面只有货猫那样)
function NoHuoMao() {
    let dm = getDomainName();
    let flag = true
    if (dm == 'hoomoo.admin.8bami.com') {
        flag = false
    }

    return flag
}
// 是否代购
function isDaiGou() {
    // getTenantType
    // let dm = getDomainName();
    // let list = [{
    //     domain: 'dev.admin.bamibuy.com' //八米购测试
    // },
    // {
    //     domain: 'live.admin.bamibuy.com' //八米购正式
    // },
    // {
    //     domain: 'xhy.dg.admin.8bami.com', //鑫华远代购演示
    // },
    // {
    //     domain: 'zt.dg.admin.8bami.com', //中坦国际(弃用)
    // },
    // {
    //     domain: 'admin.ywhhwl.com', //中坦国际
    // },
    // ];
    let flag = false
    // list.forEach(item => {
    //     if (item.domain == dm) {
    //         flag = true
    //     }
    // })

    let tenantType = window.localStorage.getItem('tenantType') || '';
    if (tenantType === 'jiyun') {
        flag = false
    } else {
        // 代购
        flag = true
    }
    return flag
}
// 获取当前语言代码
function getLanguageCode() {
    let code = 'zh-CN';
    // let code = navigator.language || navigator.userLanguage;
    // if (common.serve_s == 'dev') {
    //     code = 'zh-CN'
    // }
    return code
}

/**
 * 获取浏览器url中的参数
 */
function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    }
    return '';
}

// 处理参数,变成我想要的对象数组
function getSignArr(param) {

    let arr = [];
    for (let k in param) {
        let obj = {
            key: k,
            val: param[k],
        };
        arr.push(obj);
    }
    return arr
}


// 获取md5加密签名(第一种,弃用,有部分接口已经用了就不改了,要传个对象数组[{key:'name',val:'张三'},]没写好有点麻烦)
function getMD5Sign(param) {

    var sign = appsecret;
    //排序
    let datas = param || [];
    let sortArr = param || [];
    var newArr = [];
    for (var j = 0; j < sortArr.length; j++) {
        newArr.push(sortArr[j].key)
    }
    let arrSort = newArr.sort();
    let endArr = [];
    for (var s = 0; s < arrSort.length; s++) {
        for (var d = 0; d < datas.length; d++) {
            if (arrSort[s] == datas[d].key) {
                endArr.push(datas[d])
            }
        }
    }

    if (endArr.length == 0) {
        return
    }

    for (var i = 0; i < endArr.length; i++) {
        let val1 = endArr[i].val;
        if (val1 === 0 || val1 === '0') {

        } else {
            val1 = endArr[i].val || ''
        }
        let val = JSON.stringify(val1);
        if (!isJSON(val)) {
            val = val1 + ''
        } else {
            val = 'object'
        }
        sign = md5.hex_md5(endArr[i].key + getCharCodeArr(val) + sign);
    }
    sign = md5.hex_md5(sign + appid)
    return sign //
}
// 获取md5加密签名(第二种,用这个,直接传个对象{name:'张三'})
function getSign(param) {
    let arrs = [];
    for (let k in param) {
        let val1 = param[k];
        if (val1 == null) {
            val1 = ''
        }
        if (val1 === 0 || val1 === '0') {

        } else {
            val1 = param[k] || ''
        }
        let obj = {
            key: k,
            val: val1,
        };
        if (obj.k !== 'sign') {
            arrs.push(obj);
        }
    }
    var sign = appsecret;
    //排序
    let datas = arrs || [];
    let sortArr = arrs || [];
    var newArr = [];
    for (var j = 0; j < sortArr.length; j++) {
        newArr.push(sortArr[j].key)
    }
    let arrSort = newArr.sort();
    let endArr = [];
    for (var s = 0; s < arrSort.length; s++) {
        for (var d = 0; d < datas.length; d++) {
            if (arrSort[s] == datas[d].key) {
                endArr.push(datas[d])
            }
        }
    }

    if (endArr.length == 0) {
        return
    }
    // console.log('加密前 sign:=====' + sign)
    for (var i = 0; i < endArr.length; i++) {
        let val = JSON.stringify(endArr[i].val);
        if (!isJSON(val)) {
            val = endArr[i].val + '';
        } else {
            val = 'object'
        }

        // console.log(i + '_' + i + '   ' + '>>>>>>>> key:====' + endArr[i].key + '>>>>>>>> val:====' + val + '>>>>Ascii:====' + getCharCodeArr(val))
        sign = md5.hex_md5(endArr[i].key + getCharCodeArr(val) + sign);
        // console.log('第' + i + '次的sign :  ' + sign)
    }
    sign = md5.hex_md5(sign + appid);
    // console.log('最终结果:  ' + sign)
    return sign //
}
// 判断是否是jsop
function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }

        } catch (e) {
            console.log('error：' + str + '!!!' + e);
            return false;
        }
    }
}

function getCharCodeArr(str) {
    let strArr = str.split("");
    let strEnd = "";
    for (var i = 0; i < strArr.length; i++) {
        let code = strArr[i].charCodeAt();
        strEnd = strEnd + "" + code;
    }
    return strEnd
}

//下载.xlsx格式
function downloadFile(downloadurl) { //
    let url = window.URL.createObjectURL(new Blob([downloadurl]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", "bami_jy_export_Template.xlsx"); //指定下载后的文件名，防跳转
    document.body.appendChild(link);
    link.click();
}

//当前年月日时分秒
function getCurrentTime() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds();

    month = month < 10 ? ('0' + month) : month;
    day = day < 10 ? ('0' + day) : day;
    let sdate = year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
    return sdate
}
//当前年月日
function getCurrentDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    month = month < 10 ? ('0' + month) : month;
    day = day < 10 ? ('0' + day) : day;
    let sdate = year + '-' + month + '-' + day;
    return sdate
}

// 获取前num天或者后num天 时间
function getFlexDate(num) {
    let num1 = num || 0;
    var date1 = new Date(), //今天
        date2 = new Date(date1);
    date2.setDate(date1.getDate() + num1); //今天的前或者后几天
    // console.log('date2-----' + date2);

    var fixedM = date2.getMonth() + 1,
        fixedD = date2.getDate();

    fixedM = fixedM < 10 ? '0' + fixedM : fixedM;
    fixedD = fixedD < 10 ? '0' + fixedD : fixedD;
    var time2 = date2.getFullYear() + "-" + fixedM + "-" + fixedD;
    return time2
}
//根据非数字字母切割多个单号
function getOrderNum(srt) {
    var String = [];
    var NewArr = [];
    if (srt.length < 1) {
        // console.log('return')
        return NewArr;

    }

    let flag = /[^-0-9A-Za-z]+/;
    String = srt.split(flag);

    for (var i = 0; i < String.length; i++) {
        if (String[i]) {
            NewArr.push(String[i])
        }
    }
    return NewArr;
}


// ==========================精度计算 开始==============================================
/*
 * 判断obj是否为一个整数
 */
function isInteger(obj) {
    return Math.floor(obj) === obj
}

/*
 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
 * @param floatNum {number} 小数
 * @return {object}
 *   {times:100, num: 314}
 */
function toInteger(floatNum) {
    var ret = {
        times: 1,
        num: 0
    };
    if (isInteger(floatNum)) {
        ret.num = floatNum;
        return ret
    }
    var strfi = floatNum + ''; //转字符串
    var dotPos = strfi.indexOf('.'); //获取小数点下标
    var len = strfi.substr(dotPos + 1).length; //小数点后有几位
    var times = Math.pow(10, len); //10的len次方
    var intNum = parseInt(floatNum * times + 0.5, 10);
    ret.times = times;
    ret.num = intNum;
    return ret
}

/*
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 *
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param op {string} 运算类型，有加减乘除（add/sub/mul/divide）
 *
 */
function operation(a, b, op) {
    var o1 = toInteger(a);
    var o2 = toInteger(b);
    var n1 = o1.num;
    var n2 = o2.num;
    var t1 = o1.times;
    var t2 = o2.times;
    var max = t1 > t2 ? t1 : t2;
    var result = null;
    switch (op) {
        case 'add': //加法
            if (t1 === t2) { // 两个小数位数相同
                result = n1 + n2
            } else if (t1 > t2) { // o1 小数位 大于 o2
                result = n1 + n2 * (t1 / t2)
            } else { // o1 小数位 小于 o2
                result = n1 * (t2 / t1) + n2
            }
            return result / max;
        case 'sub': //减法
            if (t1 === t2) {
                result = n1 - n2
            } else if (t1 > t2) {
                result = n1 - n2 * (t1 / t2)
            } else {
                result = n1 * (t2 / t1) - n2
            }
            return result / max;
        case 'mul': //乘法
            result = (n1 * n2) / (t1 * t2);
            return result;
        case 'divide': //除法
            result = (n1 / n2) * (t2 / t1);
            return result
    }
}

// 加
function add(a, b) {
    return operation(a, b, 'add')
}
//减
function sub(a, b) {
    return operation(a, b, 'sub')
}
//乘
function mul(a, b) {
    return operation(a, b, 'mul')
}
//除
function divide(a, b) {
    return operation(a, b, 'divide')
}
// 四合五入  (计算金额用这个)
function mathRound(number) {
    return Math.round(number * 100) / 100 // 成功转成1.54
}
// 保留几位小数    (偶尔会出现没有四舍五入的问题,例如谷歌浏览器下 1.535 不会四舍五入,1.635.toFixed(2)可以)
function mathToFixed(number, num = 2) {
    return number.toFixed(num) // 成功转成1.54
}
// ==========================精度计算 结束==============================================


//关闭当前页面,跳转指定页面 (this.reload()要在具体页面用)
function closePage(goRoute) {

    // let currentRoute = router.fullPath
    let currentRoute = router.history.current.fullPath;
    if (currentRoute.indexOf('?') !== -1) {
        currentRoute = currentRoute.substr(0, currentRoute.indexOf('?'))
    }

    let arrs = JSON.parse(window.sessionStorage.editableTabs);
    arrs.forEach((item, index) => {
        if (item.path == currentRoute) {
            arrs.splice(index, 1);
        }
    });
    window.sessionStorage.setItem("editableTabs", JSON.stringify(arrs));
    if (goRoute) {
        router.push(goRoute);
    } else {
        router.go(-1)
    }
    // this.reload();
}
// 导出数据
function dynamicExport(myTableHeard, className, tableData, sheetName) {
    let heads = myTableHeard;
    let tableDatas = tableData || "";
    let newHeads = [];
    for (var i = 0; i < heads.length; i++) {
        let objs = {
            fieldKey: heads[i].field,
            title: heads[i].name,
        };
        newHeads.push(objs);
    }
    let param = {
        className: className || "",
        data: JSON.stringify(tableDatas),
        head: newHeads,
        sheetName: sheetName || "表名",
    };
    // let sign = tools.getSign(param);
    // param.sign = sign;
    Api.dynamicExport(param).then((res) => {
        let downloadurl = res.data.result.fileUrl || "";
        //下载(这里其实是直接访问)
        var a = document.createElement("a");
        a.setAttribute("href", downloadurl);
        a.setAttribute("target", "_blank");
        a.download = sheetName
        a.click();


        // var x = new XMLHttpRequest();

        // x.open("GET", downloadurl, true);
        // x.responseType = 'blob';
        // x.onload = function (e) {
        //     var url = window.URL.createObjectURL(x.response)
        //     var a = document.createElement('a');
        //     a.href = url
        //     a.download = sheetName;
        //     a.click()
        // }
        // x.send();
    });
}

// 获取下拉状态
async function getStatusValList(val) {
    let resData = "";
    await Api.getStatusValList({ tableAndFieldName: val })
        .then((res) => {
            resData = res.data.result || [];
        })
        .catch((error) => {});

    return resData;
}

// 检查数据类型
function jyCheckObjectType(v) {
    let s = Object.prototype.toString.call(v);
    if (s == '[object Object]') {
        return 'Object'
    } else if (s == '[object Null]') {
        return 'Null'
    } else if (s == '[object Number]') {
        return 'Number'
    } else if (s == '[object Boolean]') {
        return 'Boolean'
    } else if (s == '[object String]') {
        return 'String'
    } else if (s == '[object Array]') {
        return 'Array'
    } else if (s == '[object Date]') {
        return 'Date'
    } else if (s == '[object Function]') {
        return 'Function'
    } else if (s == '[object Undefined]') {
        return 'Undefined'
    } else {
        return s;
    }
}

// 转换数据状态
// attr是用于区分的属性
// arr1是提交的数据
// arr2是备份的数据（数据初始化的时候的详情）
function transOperationType(attr, arr1, arr2) {
    if(!arr1) arr1 = [];
    if(!arr2) arr2 = [];
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].operationType == 'UPDATE') {
            arr1[i].operationType = 'UPDATE';
        } else if(arr1[i].operationType == 'ADD'){

        }  else if(arr1[i].operationType == 'DEL'){

        } else {
            if((!arr2 ||  arr2.length === 0) || !arr1[i].operationType){
                arr1[i].operationType = 'ADD';
            }else{
                arr1[i].operationType = 'DEL';
            }
        }
    }
    for (let j = 0; j < arr2.length; j++) {
        if (arr2[j].operationType == 'ADD') {
            arr1.push(arr2[j])
        }
    }

    for (let j = 0; j < arr2.length; j++) {
        let isDel = true;
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i][attr] == arr2[j][attr]) {
                arr1[i].operationType = (arr2[j].operationType ? arr2[j].operationType : 'UPDATE');
                isDel = false;
            }
        }
        if(isDel){
            arr2[j].operationType = 'DEL';
            arr1.push(arr2[j]);
        }
    }
    return arr1;
}
// 对象属性转换
function oldObjToNewObj(oldObj, newObj) {
    for (let key in oldObj) {
        oldObj[key] = newObj[key];
    }
    return oldObj;
}


// 报关结算对象，直接使用组件objectComponents
function getSelectData(parms, type, more, ajax) {
    let najax = false;
    if (ajax) {
        najax = ajax;
    }
    return new Promise(function (resolve) {
        let obj = {
            arr: [],
            loading: false
        }
        if (obj.arr.length == 0 || najax) {
            obj.loading = true;

            // 动态接口
            if (type == 1) {
                let params = null;
                if (more) {
                    params = {
                        conditionReqs: more,
                        number: parms,
                    };
                } else {
                    params = {
                        number: parms,
                    };
                }
                Api.runReport(params).then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (data.status == "success") {
                            let result = data.result;
                            const datas = result.datas;
                            obj.loading = false;
                            obj.arr = datas;
                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            } else if (type == 2) {
                Api.getAreaContryList_q().then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (data.status == "success") {
                            let result = data.result;
                            obj.arr = result;
                            obj.loading = false;
                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            } else if (type == 3) {
                Api.getConfDictValDownList({
                    dictType: parms
                }).then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (jyCheckObjectType(data) == "Object") {
                            if (data.status == "success") {
                                const datas = data.result;
                                obj.loading = false;
                                obj.arr = datas;
                                resolve(obj);
                            } else {
                                obj.arr = [];
                                obj.loading = false;
                                resolve(obj);
                            }
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            } else if (type == 4) {

                Api.currencyList({
                    pageStart: 1,
                    pageTotal: 1000
                }).then((res) => {

                    if (res.status == 200) {
                        const data = res.data;

                        if ((data.status == "success")) {
                            let result = data.result.data;
                            obj.arr = result;
                            obj.loading = false;

                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });

            } else if (type == 5) {
                Api.getObjectUserDownList({
                    key: parms.key,
                    type: parms.type
                }).then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (data.status == "success") {
                            let result = data.result.data;
                            obj.arr = result;
                            obj.loading = false;
                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            } else if (type == 6) {
                Api.getDistrictDownList({
                    areaCountryId: parms.country,
                    districtName: parms.districtName,
                    postCode: parms.postCode,
                    level: parms.level,
                    parentId: parms.parentId
                }).then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (data.status == "success") {
                            let result = data.result;
                            obj.arr = result;
                            obj.loading = false;
                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            } else if (type == 7) {
                Api.getHasCurrencyDownList().then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (data.status == "success") {
                            let result = data.result;
                            obj.arr = result;
                            obj.loading = false;
                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            } else if (type == 8) {
                let params = ''
                if (more) {
                    params = {
                        conditionReqs: more,
                        number: parms,
                    };
                } else {
                    params = {
                        number: parms,
                    };
                }
                Api.runPageReport(params).then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (data.status == "success") {
                            let result = data.result;
                            let tempArr = result.datas.data
                            obj.arr = tempArr;
                            obj.loading = false;
                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            } else if (type == 9) {
                let params = {
                    conditionReqs: more || [],
                    number: parms,
                    pageStart: 1,
                    pageTotal: 100,
                }
                Api.runPageReport(params).then((res) => {
                    if (res.status == 200) {
                        const data = res.data;
                        if (data.status == "success") {
                            let result = data.result;
                            let tempArr = result.datas.data
                            obj.arr = tempArr;
                            obj.loading = false;
                            resolve(obj);
                        } else {
                            obj.arr = [];
                            obj.loading = false;
                            resolve(obj);
                        }
                    } else {
                        obj.arr = [];
                        obj.loading = false;
                        resolve(obj);
                    }
                }).catch(err => {
                    obj.arr = [];
                    obj.loading = false;
                    resolve(obj);
                });
            }
        } else {
            resolve(obj);
        }
    })
}
//param是表格数据,totlaList==[需要合计的字段]
function utilsgetSummaries(param, totlaList, tofixedNum) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = "合计";
            return;
        }
        if (totlaList.indexOf(column.property) != -1) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => Number.isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!Number.isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                }, 0);
                if (!Number.isNaN(sums[index])) {
                    sums[index] = sums[index].toFixed(tofixedNum || 2);
                }
            } else {
                sums[index] = "";
            }
        }
    });
    // console.log('最后的sums', sums)
    return sums;
}
//param是表格数据,totlaList==[需要合计的字段]
function utilsgetSummariesAll(param, totlaList, sumList) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = `
            小计 / 总计
            `;
            return;
        }
        if (totlaList.indexOf(column.property) != -1) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => Number.isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!Number.isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                }, 0);
                if (!Number.isNaN(sums[index])) {
                    let numA = sums[index].toFixed(2)
                    let numB = 0
                    if (sumList && sumList.length > 0) {
                        numB = Number(sumList[0][column.property] || 0)
                        numB = numB.toFixed(2)
                    }

                    sums[index] = `
                    ${numA} / ${numB}
                    `;

                    // sums[index] = `
                    // 小计: ${numA}
                    // /
                    // 总计: ${numB}
                    // `;


                }
            } else {
                sums[index] = "";
            }
        }
    });

    return sums;
}

// 获取平均值
//param是表格数据,totlaList==[需要合计的字段]
function utilsgetSummariesPJ(param, totlaList) {
    const { columns, data } = param;
    const sums = [];
    let rowNum = data.length || 0  //有几行数据
    if (rowNum < 1) {
        return false
    }

    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = "平均";
            return;
        }

        if (totlaList.indexOf(column.property) != -1) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => Number.isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!Number.isNaN(value)) {
                        let sNum = prev + curr
                        return sNum;
                    } else {
                        return prev;
                    }
                }, 0);
                if (!Number.isNaN(sums[index])) {
                    let num = sums[index] / rowNum
                    sums[index] = num.toFixed(2)
                    // sums[index] = Math.floor(num)
                }
            } else {
                sums[index] = "";
            }
        }
    });

    return sums;
}
// 根据对象的ID，获取对象的内容
function jyIDGetContent(arr, key, val) {
    const data = arr.filter((item) => {
        return item[key] == val;
    });
    if (jyCheckObjectType(data) == 'Array' && data.length > 0) {
        return data[0];
    } else {
        return null;
    }
}

// 释放对象内存
function relObjRam(obj) {
    if (jyCheckObjectType(obj) == 'Object') {
        let newobj = JSON.parse(JSON.stringify(obj));
        obj = null;
        return newobj;
    } else {
        return null;
    }
}

// 默认获取当前日期
function getNowTime() {
    var now = new Date()
    var year = now.getFullYear() // 得到年份
    var month = now.getMonth() // 得到月份
    var date = now.getDate() // 得到日期
    month = month + 1
    month = month.toString().padStart(2, '0')
    date = date.toString().padStart(2, '0')
    var defaultDate = `${year}-${month}-${date} 00:00:00`

    return defaultDate;
}
// 延迟加载
function jySleep(ms, arg) {
    let time = 85;
    if (!ms) {
        time = 300;
    } else {
        time = ms;
    }
    return new Promise((resolve) => setTimeout(resolve, time, arg));
}


// 过滤动态查询条件表单
// arr是需要过滤的数组
function filterQueryForm(arr, hideindex, nohide, span) {
    let nindex = 4;
    if (hideindex) {
        nindex = hideindex
    }
    if (!span) {
        span = 6;
    }

    let list = arr.filter(itemA => {
        return itemA.isShow == 1
    })
    list.forEach((val, key) => {
        if (nohide) {
            val.show = true;
        } else {
            if (key >= nindex - 1) {
                val.hide = true;
                val.show = false;
            } else {
                val.hide = false;
            }
        }
        val.span = span;
        val.isSlot = false;
        val.labelWidth = val.conditonKeyShow.length * 20 + "px"
    })
    return list;
}

// 转换数据状态
// attr是用于区分的属性
// arr1是提交的数据
// arr2是备份的数据（数据初始化的时候的详情）
function jyTransformDataStatus(attr, arr1, arr2) {
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].operationType == 'UPDATE') {
            arr1[i].operationType = 'UPDATE';
        } else if(arr1[i].operationType == 'ADD'){

        } else {
            arr1[i].operationType = 'DEL';
        }
    }
    for (let j = 0; j < arr2.length; j++) {
        if (arr2[j].operationType == 'ADD') {
            arr1.push(arr2[j])
        }
    }
    for (let j = 0; j < arr2.length; j++) {
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i][attr] == arr2[j][attr]) {
                arr1[i].operationType = (arr2[j].operationType ? arr2[j].operationType : 'UPDATE');
            }
        }
    }
    return arr1;
}
//把请求方法暴露出去
export default {
    getDomainName,
    getLanguageCode,
    getUrlParam,
    getMD5Sign,
    downloadFile,
    getSignArr,
    getFlexDate,
    getCurrentTime,
    getCurrentDate,
    getSign,
    getOrderNum,
    mathToFixed,
    mathRound,
    divide,
    mul,
    sub,
    add,
    closePage,
    dynamicExport,
    isDaiGou,
    NoHuoMao,
    getEnterpriseNo,
    jyCheckObjectType,
    transOperationType,
    oldObjToNewObj,
    getSelectData,
    utilsgetSummaries,
    utilsgetSummariesPJ,
    utilsgetSummariesAll,
    jyIDGetContent,
    relObjRam,
    getNowTime,
    jySleep,
    filterQueryForm,
    jyTransformDataStatus,
    getStatusValList,
    // 重置表单
    resetForm(that, formName) {
        that.$refs[formName].resetFields();
    },
}